/* Satyug Kundli mailer add-on:
 *  1. Auto-loads a chart from URL params (?d, ?t, ?lat, ?lon, ?tz, ?n)
 *     so emailed "View my Kundli" links skip straight to a summary.
 *  2. On successful contact submit, also subscribes the visitor to
 *     Shopify email marketing so the "Welcome to marketing" automation fires.
 *  3. POSTs the Kundli JSON to the configured Cloudflare Worker so the
 *     visitor receives a branded HTML email + PDF attachment via Titan SMTP.
 *  4. Adds a personalized permalink to the results screen.
 */
(function () {
  "use strict";

  var root = document.querySelector("[data-satyug-kundli]");
  if (!root) return;
  var mailerUrl = (root.getAttribute("data-mailer-url") || "").trim();

  // Wrap fetch so we can piggyback the /contact submission.
  var origFetch = window.fetch;
  window.fetch = function (url, opts) {
    var result = origFetch.apply(this, arguments);
    try {
      if (typeof url === "string" && url === "/contact" && opts && opts.method === "POST") {
        var body = opts.body;
        if (body instanceof FormData && body.get("form_type") === "contact") {
          var email = body.get("contact[email]");
          var name = body.get("contact[name]");
          var phone = body.get("contact[phone]");
          if (email) {
            // (a) Subscribe to Shopify marketing so the Welcome automation fires.
            var fd2 = new FormData();
            fd2.append("form_type", "customer");
            fd2.append("utf8", "✓");
            fd2.append("contact[tags]", "kundli-lead,newsletter");
            fd2.append("customer[email]", email);
            fd2.append("customer[first_name]", (name || "").split(" ")[0] || "");
            fd2.append("customer[last_name]", (name || "").split(" ").slice(1).join(" ") || "");
            if (phone) fd2.append("customer[phone]", phone);
            fd2.append("customer[accepts_marketing]", "1");
            origFetch("/contact", { method: "POST", body: fd2, credentials: "same-origin", redirect: "follow" }).catch(function () {});

            // (b) Fire off to the Titan SMTP relay so the visitor gets their Kundli email + PDF.
            if (mailerUrl && window._skLastKundli) {
              origFetch(mailerUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  email: email,
                  name: name || "Guest",
                  kundli: window._skLastKundli
                }),
                mode: "cors",
                credentials: "omit"
              }).then(function (r) {
                if (r.ok) console.log("[satyug] Kundli email queued for", email);
                else console.warn("[satyug] mailer", r.status);
              }).catch(function (e) { console.warn("[satyug] mailer failed", e); });
            }
          }
        }
      }
    } catch (e) {}
    return result;
  };

  // Add a "personal Kundli link" widget after results render.
  var observer = new MutationObserver(function () {
    if (!document.querySelector("[data-satyug-kundli] .sk-name-hero")) return;
    if (document.getElementById("sk-permalink-card")) return;
    var kundli = window._skLastKundli;
    if (!kundli) return;
    var url = buildPermalink(kundli);
    var card = document.createElement("div");
    card.id = "sk-permalink-card";
    card.className = "sk-card";
    card.style.cssText = "margin-top:20px;";
    card.innerHTML =
      '<h3 class="sk-title" style="text-align:left;margin:0 0 8px;font-size:20px;">Your personal Kundli link</h3>' +
      '<p style="color:var(--sk-muted);font-size:14px;margin:0 0 10px;">' + (mailerUrl ? 'A copy of your Kundli PDF is being emailed to you now. You can also bookmark this link.' : 'Bookmark or share this link — anyone opening it sees your chart instantly.') + '</p>' +
      '<div style="display:flex;gap:8px;flex-wrap:wrap;">' +
      '  <input readonly class="sk-input" value="' + escapeAttr(url) + '" style="flex:1;min-width:220px;" onclick="this.select();" />' +
      '  <button class="sk-btn-gold" id="sk-copy-link" style="padding:12px 20px;">Copy link</button>' +
      '</div>';
    var acts = document.querySelector("[data-satyug-kundli] .sk-actions:last-of-type");
    if (acts && acts.parentNode) acts.parentNode.insertBefore(card, acts);
    document.getElementById("sk-copy-link").addEventListener("click", function (e) {
      navigator.clipboard.writeText(url).then(function () {
        e.target.innerText = "Copied ✓";
        setTimeout(function () { e.target.innerText = "Copy link"; }, 1600);
      });
    });
  });
  observer.observe(root, { childList: true, subtree: true });

  // Intercept computeKundli so we can build the permalink and forward to the mailer.
  var startPatch = function () {
    if (!window.SK || !window.SK.computeKundli) return setTimeout(startPatch, 100);
    var orig = window.SK.computeKundli;
    window.SK.computeKundli = function (inp) {
      var out = orig.apply(this, arguments);
      window._skLastKundli = out;
      return out;
    };
    loadFromUrlParams();
  };
  startPatch();

  function loadFromUrlParams() {
    try {
      var p = new URLSearchParams(window.location.search);
      var d = p.get("d"), t = p.get("t"), lat = p.get("lat"), lon = p.get("lon"), tz = p.get("tz");
      var n = p.get("n"), place = p.get("p");
      if (!d || !t || !lat || !lon) return;
      var box = document.createElement("div");
      box.className = "sk-card";
      box.style.cssText = "max-width:640px;margin:24px auto;text-align:center;position:relative;overflow:hidden;";
      box.innerHTML =
        '<div class="sk-mandala"></div>' +
        '<div style="position:relative;">' +
          '<span class="sk-chip">Your Kundli, ready</span>' +
          '<h2 class="sk-title" style="margin-top:12px;">Welcome' + (n ? ", " + escapeHtml(n) : " back") + '</h2>' +
          '<p class="sk-caption">We saved your birth details. Click below to see your chart.</p>' +
          '<div class="sk-actions"><button class="sk-btn-gold" id="sk-autoload-btn">Show my Kundli</button></div>' +
        '</div>';
      root.insertBefore(box, root.firstChild);
      document.getElementById("sk-autoload-btn").addEventListener("click", function () {
        box.remove();
        var kundli = window.SK.computeKundli({
          name: n || "Guest", date: d, time: t, place: place || "",
          latitude: parseFloat(lat), longitude: parseFloat(lon),
          tzOffsetMinutes: parseInt(tz || "0", 10)
        });
        renderStandalone(kundli);
      });
    } catch (e) {}
  }

  function renderStandalone(k) {
    var wrap = document.createElement("div");
    wrap.className = "sk-wrap";
    wrap.style.cssText = "padding:20px 0;";
    wrap.innerHTML =
      '<div style="text-align:center;">' +
      '  <span class="sk-chip">Your Kundli</span>' +
      '  <h2 class="sk-name-hero">' + escapeHtml(k.input.name) + '</h2>' +
      '  <p class="sk-birth-line">' + escapeHtml(k.input.date + " · " + k.input.time + " · " + k.input.place) + '</p>' +
      '  <div class="sk-divider"></div>' +
      '</div>' +
      '<div class="sk-facts" style="grid-template-columns:repeat(auto-fill,minmax(200px,1fr));">' +
      '  <div class="sk-fact"><div class="k">Ascendant / Lagna</div><div class="v">' + k.ascendant.en + ' ' + k.ascendant.sa + '</div><div class="m">Ruler: ' + k.ascendant.lord + '</div></div>' +
      '  <div class="sk-fact"><div class="k">Moon Sign</div><div class="v">' + k.moon.en + ' ' + k.moon.sa + '</div><div class="m">Nakshatra ' + k.moon.nak + ' · Pada ' + k.moon.pada + '</div></div>' +
      '  <div class="sk-fact"><div class="k">Current Dasha</div><div class="v">' + k.dashas.current.lord + ' → ' + k.dashas.currentAntar.lord + '</div><div class="m">Panchang: ' + k.panchang.tithi + '</div></div>' +
      '</div>' +
      '<p style="text-align:center;margin-top:24px;color:var(--sk-muted);">For the full report with planetary positions, doshas, dashas and product recommendations, use the form below to enter your details again.</p>';
    root.appendChild(wrap);
  }

  function buildPermalink(k) {
    var base = window.location.origin + window.location.pathname;
    var p = new URLSearchParams();
    p.set("n", k.input.name); p.set("d", k.input.date); p.set("t", k.input.time);
    p.set("p", k.input.place); p.set("lat", k.input.latitude);
    p.set("lon", k.input.longitude); p.set("tz", k.input.tzOffsetMinutes);
    return base + "?" + p.toString();
  }

  function escapeHtml(s) { return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;"); }
  function escapeAttr(s) { return String(s).replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/</g,"&lt;"); }
})();
